require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-he-break-the-bias.json") })
        }
      }, "path---insights-he-break-the-bias");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-he-break-the-bias!./.cache/json/insights-he-break-the-bias.json
// module id = 1125
// module chunks = 231608221292675